export const tuple = <T extends string[]>(...args: T) => args;

export function generateGuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function omit<T extends object, K extends keyof T>(obj: T, fields: K[]) {
  const clone = { ...obj };
  fields.forEach((key) => {
    delete clone[key];
  });
  return clone;
}
export function pick<T extends Object, K extends keyof T>(
  obj: T,
  fields: K[]
): Pick<T, K> {
  let clone = {};
  fields.forEach((key) => {
    (clone as any)[key] = obj[key];
  });
  return clone as Pick<T, K>;
}